import { useFilesystemStore, useMessageStore } from "@/state/stores";
import { useShallow } from "zustand/react/shallow";

/**
 * Hook that checks if any data is currently being processed
 * @returns true if any messages, files, or message parts are being processed
 */
export function useIsProcessing() {
  const isMessageProcessing = useMessageStore(
    useShallow((state) => {
      return state.messages.some((message) => {
        // Check message status
        if (message.status === "pending" || message.status === "processing") {
          return true;
        }

        // Check message parts if they exist
        if (message.parts) {
          return message.parts.some((part) => {
            if (part.type === "text" && part.status === "streaming") {
              return true;
            }
            if (
              part.type === "tool-call" &&
              (part.status === "pending" || part.status === "executing")
            ) {
              return true;
            }
            return false;
          });
        }

        return false;
      });
    }),
  );

  const isFileProcessing = useFilesystemStore(
    useShallow((state) => {
      return state.stagedFiles.some((file) => file.status === "processing");
    }),
  );

  return isMessageProcessing || isFileProcessing;
}
